import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { anunciosService, getFotoUrl } from '../services/api'
import Selo from '../components/Selo'
import AnuncioCard from '../components/AnuncioCard'
import './Home.css'

const categorias = [
    { id: 'bovino', nome: 'Bovinos', icone: '🐄', cor: '#22c55e' },
    { id: 'equino', nome: 'Equinos', icone: '🐴', cor: '#3b82f6' },
    { id: 'suino', nome: 'Suínos', icone: '🐷', cor: '#f59e0b' },
    { id: 'ovino', nome: 'Ovinos', icone: '🐑', cor: '#8b5cf6' },
    { id: 'aves', nome: 'Aves', icone: '🐓', cor: '#ef4444' },
    { id: 'outros', nome: 'Outros', icone: '📦', cor: '#64748b' }
]

function Home() {
    const { usuario, isLogado } = useAuth()
    const navigate = useNavigate()
    const [anunciosDestaque, setAnunciosDestaque] = useState([])
    const [loading, setLoading] = useState(true)
    const [termoBusca, setTermoBusca] = useState('')

    const [activePlano, setActivePlano] = useState(0);
    const planosRef = useRef(null);

    const handleScroll = () => {
        if (!planosRef.current) return;
        const scrollPosition = planosRef.current.scrollLeft;
        const containerWidth = planosRef.current.offsetWidth;
        const newIndex = Math.round(scrollPosition / (planosRef.current.scrollWidth / 3));
        if (newIndex !== activePlano) {
            setActivePlano(newIndex);
        }
    };

    useEffect(() => {
        carregarDestaques()
        
        // Centraliza no plano Premium (índice 1) ao carregar no mobile
        if (window.innerWidth <= 768 && planosRef.current) {
            setTimeout(() => {
                const scrollAmount = planosRef.current.scrollWidth / 3;
                planosRef.current.scrollTo({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
                setActivePlano(1);
            }, 500);
        }
    }, [])

    const carregarDestaques = async () => {
        try {
            // Busca os anúncios ordenados por selo (ouro primeiro) e limita a 10
            const response = await anunciosService.listar({
                ordenar: 'selo',
                limite: 10
            })
            setAnunciosDestaque(response.anuncios || [])
        } catch (error) {
            console.error('Erro ao carregar destaques:', error)
        } finally {
            setLoading(false)
        }
    }

    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0
        }).format(value)
    }

    const handleSearch = (e) => {
        e.preventDefault()
        if (termoBusca.trim()) {
            navigate(`/anuncios?busca=${encodeURIComponent(termoBusca)}`)
        }
    }

    const renderHeroContent = () => {
        const isVisitante = !isLogado

        return (
            <div className="hero-content">
                <h1 className="hero-title">
                    O marketplace do
                    <span className="hero-highlight"> produtor rural</span>
                </h1>
                <p className="hero-subtitle">
                    Conectamos produtores, compradores e transportadores em um só lugar, com total transparência e segurança.
                </p>

                {/* Barra de Pesquisa */}
                <form className="hero-search" onSubmit={handleSearch}>
                    <input
                        type="text"
                        placeholder="O que você procura?"
                        value={termoBusca}
                        onChange={(e) => setTermoBusca(e.target.value)}
                    />
                    <button type="submit" className="btn btn-primary">Buscar</button>
                </form>

                <div className="hero-actions">
                    {isVisitante ? (
                        <Link to="/cadastro" className="btn btn-outline btn-lg">
                            Anunciar Agora
                        </Link>
                    ) : (
                        <Link to="/criar-anuncio" className="btn btn-outline btn-lg">
                            Anunciar Agora
                        </Link>
                    )}
                    <Link to="/ajuda" className="btn btn-secondary btn-lg">
                        Como funciona?
                    </Link>
                </div>
            </div>
        )
    }

    const handlePlanoSelecionado = async (plano) => {
        if (!isLogado) {
            navigate('/login')
            return
        }

        // Verificações de planos já ativos
        const isPremiumAtivo = usuario?.assinatura_ilimitada === true && 
                               usuario?.expiracao_assinatura && 
                               new Date(usuario?.expiracao_assinatura) > new Date();
        
        const isMotoristaAtivo = (usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true) && 
                                  usuario?.expiracao_motorista && 
                                  new Date(usuario?.expiracao_motorista) > new Date();

        if (plano === 'anuncios_ilimitados' && isPremiumAtivo) {
            alert('Você já possui o Plano Produtor Premium ativo!');
            navigate('/criar-anuncio');
            return;
        }

        if (plano === 'anuncio_avulso' && isPremiumAtivo) {
            alert('Você já possui anúncios ilimitados com seu Plano Premium!');
            navigate('/criar-anuncio');
            return;
        }

        if (plano === 'motorista') {
            navigate('/adicionar-tipo?tipo=motorista');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const resp = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/pagamentos/checkout-anuncio`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ plano })
            });
            const data = await resp.json();
            if (data.url) {
                window.location.href = data.url;
            } else {
                alert('Erro ao gerar pagamento');
            }
        } catch (e) {
            console.error(e);
            alert('Falha na comunicação com gateway de pagamento');
        }
    };
    const podeVerDetalhes = isLogado && usuario?.perfilCompleto;

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                {renderHeroContent()}
                <div className="hero-visual">
                    <div className="hero-image-container">
                        <img
                            src="/logo/agroov-hero-novo.png"
                            alt="Fazenda brasileira ao pôr do sol"
                            className="hero-image"
                        />
                    </div>
                </div>
            </section>



            {/* Anúncios em Destaque */}
            <section className="section">
                <div className="section-header">
                    <h2 className="section-title">Anúncios em Destaque</h2>
                </div>
                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Carregando destaques...</p>
                    </div>
                ) : (
                    <>
                        <div className="anuncios-grid">
                            {anunciosDestaque.length > 0 ? (
                                anunciosDestaque.map((anuncio) => (
                                    <AnuncioCard 
                                        key={anuncio.id}
                                        anuncio={anuncio}
                                        podeVerDetalhes={podeVerDetalhes}
                                        isLogado={isLogado}
                                        usuario={usuario}
                                    />
                                ))
                            ) : (
                                <div className="sem-destaques">
                                    <p>Nenhum anúncio em destaque no momento.</p>
                                </div>
                            )}
                        </div>
                        {anunciosDestaque.length > 0 && (
                            <div className="ver-todos-container">
                                <Link to="/anuncios" className="btn-ver-todos">
                                    Explorar todos os anúncios
                                </Link>
                            </div>
                        )}
                    </>
                )}
            </section>

            {/* Planos e Valores */}
            <section id="planos" className="section planos-section">
                <div className="section-header center" style={{ flexDirection: 'column', gap: '10px' }}>
                    <h2 className="section-title text-center" style={{ margin: 0 }}>Nossos Planos / Oportunidades</h2>
                    <p className="section-subtitle text-center" style={{ color: 'var(--color-text-secondary)', fontSize: '1.1rem' }}>Transparência total. Escolha como quer participar de nosso marketplace.</p>
                </div>
                <div 
                    className="planos-grid" 
                    ref={planosRef}
                    onScroll={handleScroll}
                >
                    {/* Plano 1 - Anúncio Avulso */}
                    <div className="plano-card">
                        <div className="plano-badge basico-badge">Mais Popular</div>
                        <h3 className="plano-nome">Anúncio Avulso</h3>
                        <div className="plano-preco">
                            <span className="currency">R$</span>
                            <span className="valor">49</span>
                            <span className="cents">,90</span>
                            <span className="periodo">/ anúncio</span>
                        </div>
                        <ul className="plano-features">
                            <li>✓ Publicação de 1 anuncio</li>
                            <li>✓ <strong>Validade de 30 dias</strong></li>
                            <li>✓ 1 repostagem no Instagram</li>
                            <li>✓ Fotos e vídeos</li>
                            <li>✓ Negociação direta</li>
                        </ul>
                        <button className="btn btn-outline btn-block mt-4" onClick={() => handlePlanoSelecionado('anuncio_avulso')}>Anunciar Agora</button>
                    </div>

                    {/* Plano 2 - Produtor Premium (Destaque) */}
                    <div className="plano-card destaque">
                        <div className="plano-badge destaque-badge">Ilimitado</div>
                        <h3 className="plano-nome" style={{color: 'white'}}>Produtor Premium</h3>
                        <div className="plano-preco" style={{color: 'white'}}>
                            <span className="currency">R$</span>
                            <span className="valor">149</span>
                            <span className="cents">,90</span>
                            <span className="periodo">/ mês</span>
                        </div>
                        <ul className="plano-features" style={{color: 'rgba(255,255,255,0.9)'}}>
                            <li>✓ <strong>Anuncios ilimitados</strong></li>
                            <li>✓ <strong>Validade de 60 dias por anúncio</strong></li>
                            <li>✓ Repostagem ilimitada no Instagram</li>
                            <li>✓ Maior visibilidade na home</li>
                            <li>✓ Suporte prioritário</li>
                        </ul>
                        <button className="btn btn-secondary btn-block mt-4" onClick={() => handlePlanoSelecionado('anuncios_ilimitados')}>Assinar Premium</button>
                    </div>

                    {/* Plano 3 - Transportador */}
                    <div className="plano-card">
                        <div className="plano-badge motorista-badge">Motoristas</div>
                        <h3 className="plano-nome">Transportador</h3>
                        <div className="plano-preco">
                            <span className="currency">R$</span>
                            <span className="valor">49</span>
                            <span className="cents">,90</span>
                            <span className="periodo">/ mês</span>
                        </div>
                        <ul className="plano-features">
                            <li>✓ Nome na lista de motoristas oficiais</li>
                            <li>✓ Se candidatar a anuncios</li>
                            <li>✓ Postagens no instagram</li>
                            <li>✓ Perfil verificado com selo</li>
                        </ul>
                        <button className="btn btn-outline btn-block mt-4" onClick={() => handlePlanoSelecionado('motorista')}>Quero Transportar</button>
                    </div>
                </div>

                {/* Indicadores de Paginação (Dots) */}
                <div className="planos-dots">
                    <span className={`dot ${activePlano === 0 ? 'active' : ''}`}></span>
                    <span className={`dot ${activePlano === 1 ? 'active' : ''}`}></span>
                    <span className={`dot ${activePlano === 2 ? 'active' : ''}`}></span>
                </div>
            </section>




        </div>
    )
}

export default Home
